import { Linkedin, Youtube, Instagram, Music2, Github, Facebook, Twitter, Globe } from 'lucide-react';

const PLATFORMS = [
  { key: 'linkedin', label: 'LinkedIn', icon: Linkedin, match: (host) => host.includes('linkedin.com') },
  { key: 'youtube', label: 'YouTube', icon: Youtube, match: (host) => host.includes('youtube.com') || host.includes('youtu.be') },
  { key: 'instagram', label: 'Instagram', icon: Instagram, match: (host) => host.includes('instagram.com') },
  { key: 'tiktok', label: 'TikTok', icon: Music2, match: (host) => host.includes('tiktok.com') },
  { key: 'github', label: 'GitHub', icon: Github, match: (host) => host.includes('github.com') },
  { key: 'facebook', label: 'Facebook', icon: Facebook, match: (host) => host.includes('facebook.com') || host.includes('fb.com') },
  { key: 'twitter', label: 'X (Twitter)', icon: Twitter, match: (host) => host.includes('twitter.com') || host.includes('x.com') },
];

const normalizeUrl = (value) => {
  const trimmed = (value || '').trim();
  if (!trimmed) return '';
  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  return `https://${trimmed}`;
};

const detectPlatform = (url) => {
  const normalized = normalizeUrl(url);
  try {
    const host = new URL(normalized).hostname.replace(/^www\./, '').toLowerCase();
    const platform = PLATFORMS.find((p) => p.match(host));
    if (platform) return { label: platform.label, icon: platform.icon, url: normalized };
    return { label: host, icon: Globe, url: normalized };
  } catch {
    return { label: 'Website', icon: Globe, url: normalized };
  }
};

const isValidUrl = (value) => {
  const normalized = normalizeUrl(value);
  if (!normalized) return false;
  try {
    new URL(normalized);
    return true;
  } catch {
    return false;
  }
};

const openExternalLink = (url) => {
  const normalized = normalizeUrl(url);
  const confirmed = window.confirm(`You are about to leave YeniDers and visit:\n${normalized}\n\nDo you want to continue?`);
  if (confirmed) {
    window.open(normalized, '_blank', 'noopener,noreferrer');
  }
};

export { detectPlatform, normalizeUrl, isValidUrl, openExternalLink };
